import { Delete, Edit } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import companyEmployeeService from "../../services/companyEmployeeService";
import companyService from "../../services/companyService";
import CompanyEmployeeAddModal from "./CompanyEmployeeAddModal";
import CompanyEmployeeDeleteModal from "./CompanyEmployeeDeleteModal";
import CompanyEmployeeEditModal from "./CompanyEmployeeEditModal";
import MaterialTable from "material-table";
import { defaultTableOptions, tableIcons } from "../../shared/tableHelper";

const AdminCompanyEmployeesTable = (props) => {

	let [ companyEmployees, setCompanyEmployees ] = useState(null);
	let [ deleteEmployee, setDeleteEmployee ] = useState(null);
	let [ editEmployee, setEditEmployee ] = useState(null);
	let [ showAddEmployee, setShowAddEmployee ] = useState(false);
	let [ showAddEmployeeLoading, setShowAddEmployeeLoading ] = useState(false);
	
	// EDIT EMPLOYEE
	const handleEditClick = (employee) => {
		setEditEmployee(employee);
	};
	
	const handleEditClose = () => {
		setEditEmployee(null);
	};
	
	const handleEditSubmit = (employee) => {
		companyEmployeeService.update(employee)
		.then(() => {
			setCompanyEmployees(companyEmployeeService.companyEmployees);
		})
		.catch((err) => {
			console.log(`Error editing employee: ${err.message}`);
		})
		.finally(() => {
			setEditEmployee(null);
		});
	};
	
	// DELETE EMPLOYEE
	const handleDeleteClick = (employee) => {
		setDeleteEmployee(employee);
	};
	
	const handleConfirmDelete = (employee) => {
		if (employee) {
			companyEmployeeService.delete(deleteEmployee)
			.then(() => {
				setCompanyEmployees(companyEmployeeService.companyEmployees);
			})
			.catch((err) => {
				console.log(`Error deleting employee: ${err.message}`);
			})
			.finally(() => {
				setDeleteEmployee(null);
			});
		}
		else {
			setDeleteEmployee(null);
		}
	};
	
	// ADD EMPLOYEE
	const handleAddClick = () => {
		setShowAddEmployee(true);
	};
	
	const handleAddClose = () => {
		setShowAddEmployee(false);
	};
	
	const handleAddSubmit = (employee) => {
		setShowAddEmployeeLoading(true);
		employee.company_id = companyService.selectedCompany.id;
		companyEmployeeService.add(employee)
		.then(() => {
			setCompanyEmployees(companyEmployeeService.companyEmployees);
		})
		.catch((err) => {
			console.log(`Error adding employee: ${err.message}`);
		})
		.finally(() => {
			setShowAddEmployee(false);
			setShowAddEmployeeLoading(false);
		});
	};
	
	useEffect(() => {
		setCompanyEmployees(companyEmployeeService.companyEmployees);
	}, [ props.company ]);
	
	return (
		<Stack sx={{ width: "80%", margin: "1em auto", /*maxHeight: "40em",*/ overflow: "auto" }}>
			<Typography variant="h6" sx={{ margin: "1em" }}>Company Employees</Typography>
			{(companyEmployees && companyEmployees.length > 0)?
				<MaterialTable
					icons={tableIcons}
					columns={[
						{ title: "Email", field: "email" },
						{ title: "Firstname", field: "firstname" },
						{ title: "Lastname", field	: "lastname" }
					]}
					actions={[
						{
							icon: () => <Edit/>,
							tooltip: "Edit",
							onClick: (event, rowData) => { handleEditClick(rowData) }
						},
						{
							icon: () => <Delete/>,
							tooltip: "Delete",
							onClick: (event, rowData) => { handleDeleteClick(rowData) }
						}
					]}
					data={companyEmployees}
					title=""
					options={defaultTableOptions}
				/>
			: <MaterialTable icons={tableIcons} title="" options={defaultTableOptions}/>}
			<Button onClick={handleAddClick} sx={{float: "right"}}>+ Add Company Employee</Button>
			<CompanyEmployeeDeleteModal
				employee={deleteEmployee}
				onConfirm={handleConfirmDelete}
			/>
			<CompanyEmployeeAddModal
				loading={showAddEmployeeLoading}
				open={showAddEmployee}
				onClose={handleAddClose}
				onSubmit={handleAddSubmit}
			/>
			<CompanyEmployeeEditModal
				employee={editEmployee}
				onClose={handleEditClose}
				onSubmit={handleEditSubmit}
			/>
		</Stack>
	);

}

export default AdminCompanyEmployeesTable;